module.exports = __webpack_public_path__ + "logo-rcbc_aa9b69a12f67579c7db0b6d838f374bc.png";